import locales from './validationLocales';
var validation = {
  locales: {
    ns: 'validation',
    resources: locales
  }
};
export default validation;